<template>
  <Modal
    :title="title"
    :openModal="display"
    v-on:close-modal="$emit('close-modal')"
  >
    <template v-slot:content>
      <form
        action=""
        @submit.prevent="handleClick"
        id="activateDisbursalsForm"
      ></form>
    </template>
    <template v-slot:footer>
      <Button
        type="submit"
        form="activateDisbursalsForm"
        styling="primary"
        text="Activate"
      ></Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal/Modal.vue';
import Button from '../../components/Button/Button.vue';

export default {
  name: 'DisbursalModal',
  emits: ['close-modal'],
  props: ['borrower', 'display'],
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      title: 'Enable Automatic Disbursals',
    };
  },
  methods: {
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to enable automatic disbursals for this borrower?`,
        button: {
          no: 'Cancel',
          yes: 'Yes',
        },
        callback: (confirm) => {
          if (confirm) {
            this.enableDisbursals();
          }
        },
      });
    },
    enableDisbursals() {
      const { ref } = this.borrower;
      this.$store
        .dispatch(`borrowers/enableDisbursals`, {
          ref,
        })
        .then(() => {
          this.$emit('close-modal');
        })
        .catch((err) => {
          this.formErrors = err;
        });
    },
    checkBorrower() {
      if (this.borrower !== null) {
        this.title = `Enable Automatic Disbursals for ${this.borrower.name}?`;
      }
    },
  },
  watch: {
    borrower: {
      handler() {
        this.checkBorrower();
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.borrower) this.$emit('close-modal');
    else this.checkBorrower();
  },
};
</script>
